export default function(ac, app) {
    var poreznaStopa = app.getEntity('PoreznaStopa');

    poreznaStopa.listView()
        .title('Porezne stope')
        .icon('<i class="fa fa-bar-chart fa-3x"></i>')
        .fields([
            ac.field('naziv')
                .label('Naziv stope')
                .cssClasses(['col-md-3']),
            ac.field('stopa')
                .cssClasses(['col-md-2']),
            ac.field('vazi_od', 'date')
                .label('Važi od')
                .cssClasses(['col-md-3']),
            ac.field('vazi_do', 'date')
                .label('Važi do')
                .cssClasses(['col-md-3']),
        ])
        .listActions([
            'edit',
            'delete'
        ]);

    poreznaStopa.editionView()
        .title('Porezna stopa')
        .fields([
            {
                key:'naziv',
                type: 'hInput',
                templateOptions: {
                    label: 'Naziv stope',
                    required: true,
                    focus: true
                }
            },
            {
                key: 'stopa',
                type: 'hInput',
                templateOptions: {
                    label: 'Stopa(%)',
                    required: true
                }
            },
            {
                key: 'vazi_od',
                type: 'hDatepicker',
                templateOptions: {
                    label: 'Važi od',
                    required: true
                }
            },
            {
                key: 'vazi_do',
                type: 'hDatepicker',
                templateOptions: {
                    label: 'Važi do',
                }
            },

        ]);

    return poreznaStopa;
}



// WEBPACK FOOTER //
// ./app/components/poreznaStopa/config.js